/**
 * Permission Request Dialog
 * Shown while the browser's native permission prompt is displayed
 */

import React from 'react'
import { Dialog, DialogContent, Box, Typography, CircularProgress } from '@mui/material'
import { useBrowserDetection } from 'src/customHooks/mediaPermissions'

export const PermissionRequestDialog = ({ open, mediaType = 'both' }) => {
  const { browser } = useBrowserDetection()

  const getPromptLocation = () => {
    switch (browser) {
      case 'chrome':
      case 'edge':
        return 'Look for the permission prompt at the top of your browser, near the address bar'
      case 'safari':
        return 'Look for the permission prompt at the top of your browser'
      case 'firefox':
        return 'Look for the permission prompt in your address bar'
      default:
        return 'Look for the permission prompt in your browser'
    }
  }

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      aria-labelledby="permission-request-title"
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 3,
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
            textAlign: 'center',
          }}
        >
          <CircularProgress size={60} sx={{ color: '#514387' }} />
          
          <Box>
            <Typography
              id="permission-request-title"
              variant="h6"
              component="h2"
              fontWeight="bold"
              gutterBottom
            >
              Click "Allow" in the Browser Prompt
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {getPromptLocation()}
            </Typography>
          </Box>

          <Box
            sx={{
              p: 2,
              backgroundColor: '#f5f5f5',
              borderRadius: 1,
              width: '100%',
            }}
          >
            <Typography variant="body2" color="text.secondary">
              💡 Tip: Make sure to click <strong>"Allow"</strong> or <strong>"Allow always"</strong> when
              the browser asks for permission
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default PermissionRequestDialog


















